const fileToDataURL = (file: Blob): Promise<any> => {
    return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = (e) => resolve((e.target as FileReader).result)
        reader.readAsDataURL(file)
    })
}
const dataURLToImage = (dataURL: string): Promise<HTMLImageElement> => {
    return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.src = dataURL
    })
}
const canvastoFile = (canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob | null> => {
    return new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), type, quality))
}
/**
 * 图片压缩方法
 * @param {Object}  file 图片文件
 * @param {String} type 想压缩成的文件类型
 * @param {Nubmber} quality 压缩质量参数
 * @returns 压缩后的新图片
 */
export const compressionFile = async(file: any, edg = 0, type = 'image/jpeg', quality = 0.5) => {
    const fileName = file.name
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d') as CanvasRenderingContext2D
    const base64 = await fileToDataURL(file)
    const img = await dataURLToImage(base64)
    canvas.width = img.width
    canvas.height = img.height
    context.clearRect(0, 0, img.width, img.height)
    context.drawImage(img, 0, 0, img.width, img.height)

    if (edg % 90 != 0) {
        throw '旋转角度必须是90的倍数!';
    }
    edg < 0 && (edg = (edg % 360) + 360);
    const quadrant = (edg / 90) % 4; //旋转象限
    const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标
    const imgW = img.width;
    const imgH = img.height;
    const size = imgW > imgH ? imgW : imgH;
    canvas.width = size * 2;
    canvas.height = size * 2;
    switch (quadrant) {
        case 0:
            cutCoor.sx = size;
            cutCoor.sy = size;
            cutCoor.ex = size + imgW;
            cutCoor.ey = size + imgH;
            break;
        case 1:
            cutCoor.sx = size - imgH;
            cutCoor.sy = size;
            cutCoor.ex = size;
            cutCoor.ey = size + imgW;
            break;
        case 2:
            cutCoor.sx = size - imgW;
            cutCoor.sy = size - imgH;
            cutCoor.ex = size;
            cutCoor.ey = size;
            break;
        case 3:
            cutCoor.sx = size;
            cutCoor.sy = size - imgW;
            cutCoor.ex = size + imgH;
            cutCoor.ey = size + imgW;
            break;
    }
    context?.translate(size, size);
    context?.rotate((edg * Math.PI) / 180);
    //drawImage向画布上绘制图片
    context?.drawImage(img, 0, 0);
    //getImageData() 复制画布上指定矩形的像素数据
    const imgData = context?.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey) as any;
    if (quadrant % 2 == 0) {
        canvas.width = imgW;
        canvas.height = imgH;
    } else {
        canvas.width = imgH;
        canvas.height = imgW;
    }
    //putImageData() 将图像数据放回画布
    context?.putImageData(imgData, 0, 0);


    const blob = (await canvastoFile(canvas, type, quality)) as Blob // quality:0.5可根据实际情况计算
    const newFile = await new File([blob], fileName, {
        type: type
    })
    return newFile
}

// 旋转
export const rotateBase64Img = (src: string, edg: number, callback: (e: any) => any) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let imgW; //图片宽度
    let imgH; //图片高度
    let size; //canvas初始大小
    if (edg % 90 != 0) {
        throw '旋转角度必须是90的倍数!';
    }
    edg < 0 && (edg = (edg % 360) + 360);
    const quadrant = (edg / 90) % 4; //旋转象限
    const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = src;
    image.onload = function () {
        imgW = image.width;
        imgH = image.height;
        size = imgW > imgH ? imgW : imgH;
        canvas.width = size * 2;
        canvas.height = size * 2;
        switch (quadrant) {
            case 0:
                cutCoor.sx = size;
                cutCoor.sy = size;
                cutCoor.ex = size + imgW;
                cutCoor.ey = size + imgH;
                break;
            case 1:
                cutCoor.sx = size - imgH;
                cutCoor.sy = size;
                cutCoor.ex = size;
                cutCoor.ey = size + imgW;
                break;
            case 2:
                cutCoor.sx = size - imgW;
                cutCoor.sy = size - imgH;
                cutCoor.ex = size;
                cutCoor.ey = size;
                break;
            case 3:
                cutCoor.sx = size;
                cutCoor.sy = size - imgW;
                cutCoor.ex = size + imgH;
                cutCoor.ey = size + imgW;
                break;
        }
        ctx?.translate(size, size);
        ctx?.rotate((edg * Math.PI) / 180);
        //drawImage向画布上绘制图片
        ctx?.drawImage(image, 0, 0);
        //getImageData() 复制画布上指定矩形的像素数据
        const imgData = ctx?.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey) as any;
        if (quadrant % 2 == 0) {
            canvas.width = imgW;
            canvas.height = imgH;
        } else {
            canvas.width = imgH;
            canvas.height = imgW;
        }
        //putImageData() 将图像数据放回画布
        ctx?.putImageData(imgData, 0, 0);
        callback(canvas.toDataURL('image/png'));
    };
}